import { useState, useEffect } from "react";
import { Link, NavLink, Navigate } from "react-router-dom";
import { isEmpty } from "lodash";
import {
  MdOutlineAccessTime,
  MdOutlinePowerSettingsNew,
  MdOutlinePieChart,
  MdNotifications,
  MdOutlineHistoryEdu
} from "react-icons/md";
import { HiOutlineHome } from "react-icons/hi";
import { logo } from "../../../assets";
import { decodeJWT } from "../../../utils";
import NewsModal from "../../../helpers/NewsModal/NewsModal";
import ColorChangingIcon from "../../../helpers/ColorChangingIcon/ColorChangingIcon";
import { AiFillNotification } from "react-icons/ai";

const PublicPcMenu = () => {
  const [openModal, setOpenModal] = useState(false);
  const token = localStorage.getItem("token");
  const isLogin = !isEmpty(token);
  const roleName = decodeJWT(token)?.usertype;

  useEffect(() => {
    setOpenModal(true);
  }, []);

  if (!isLogin) return <Navigate to="/" replace />;

  return (
    <div className="fixed z-10 top-0 pb-3 px-6 w-full lg:flex hidden flex-col justify-between h-screen border-l border-yellow-600 bg-gray-200 transition duration-300 md:w-4/12 lg:ml-0 lg:w-[25%] xl:w-[20%] 2xl:w-[15%]">
      {/* Header Section */}
      <div className="flex flex-col items-center pt-6">
        <div className="flex flex-col items-center mb-6">
          <img
            src={logo}
            width={150}
            className="bg-cover mb-2"
            alt="Website Logo"
          />
          <p className="text-black text-lg font-medium">هو الرزاق</p>
        </div>

        <div className="flex justify-between w-full px-4 mb-8">
          <button
            onClick={() => setOpenModal(!openModal)}
            className="p-2 rounded-full hover:bg-yellow-50 transition"
          >
            <ColorChangingIcon
              Icon={AiFillNotification}
              size={25}
              className="animate__animated animate__swing animate__slow animate__infinite"
              firstColor="#facc15"
              secondColor="#000"
            />
          </button>

          <NavLink
            to="/Log-Out"
            className="p-2 rounded-full hover:bg-yellow-50 transition"
          >
            <MdOutlinePowerSettingsNew size={25} className="text-yellow-600" />
          </NavLink>
        </div>
      </div>

      {/* Main Content Area */}
      <div className="flex-grow flex flex-col">
        {/* Navigation Menu */}
        <ul className="space-y-3 tracking-wide text-black font-medium">
          <li>
            <NavLink
              to="/Public/Home"
              className={({ isActive }) =>
                isActive
                  ? "relative px-4 py-3 flex items-center space-x-4 bg-yellow-100 rounded-xl cursor-pointer border border-yellow-300"
                  : "relative px-4 py-3 flex items-center space-x-4 rounded-xl hover:bg-yellow-50 cursor-pointer"
              }
            >
              <HiOutlineHome size={25} className="ml-2 text-yellow-600" />
              <span className="-mr-1">صفحه اصلی</span>
            </NavLink>
          </li>

          <li>
              <NavLink
                to="/Public/Live-Transactions"
                className={({ isActive }) =>
                  isActive
                    ? "relative px-4 py-3 flex items-center space-x-4 bg-yellow-100 rounded-xl cursor-pointer border border-yellow-300"
                  : "relative px-4 py-3 flex items-center space-x-4 rounded-xl hover:bg-yellow-50 cursor-pointer"
                }
              >
                <span className="flex">
                  <MdOutlineHistoryEdu size={25} className="ml-2 text-yellow-600" />
                  <span className="-mr-1 mt-1">معاملات جاری</span>
                </span>
              </NavLink>
            </li>


          <li>
            <NavLink
              to="/Public/Last-Transactions"
              className={({ isActive }) =>
                isActive
                  ? "relative px-4 py-3 flex items-center space-x-4 bg-yellow-100 rounded-xl cursor-pointer border border-yellow-300"
                  : "relative px-4 py-3 flex items-center space-x-4 rounded-xl hover:bg-yellow-50 cursor-pointer"
              }
            >
              <MdOutlineAccessTime size={25} className="ml-2 text-yellow-600" />
              <span className="-mr-1">آخرین معاملات</span>
            </NavLink>
          </li>

          <li>
            <NavLink
              to={
                roleName === "ADMIN"
                  ? "/Admin/Dashboard/Profile"
                  : "/Customer/Profile"
              }
              className={({ isActive }) =>
                isActive
                  ? "relative px-4 py-3 flex items-center space-x-4 bg-yellow-100 rounded-xl cursor-pointer border border-yellow-300"
                  : "relative px-4 py-3 flex items-center space-x-4 rounded-xl hover:bg-yellow-50 cursor-pointer"
              }
            >
              <MdOutlinePieChart size={25} className="ml-2 text-yellow-600" />
              <span className="-mr-1">داشبورد</span>
            </NavLink>
          </li>

          {/* News Modal positioned right after the dashboard button */}
          <li className="w-full">
            {openModal && (
              <NewsModal viewTag="pc" onClose={() => setOpenModal(false)} />
            )}
          </li>
        </ul>

        {/* Spacer to push footer down */}
        <div className="flex-grow"></div>
      </div>

      {/* Footer Section */}
      <div className="px-6 -mx-6 py-4 flex justify-center items-center "></div>
    </div>
  );
};

export default PublicPcMenu;
